import { LocalFileSystemID, FailureType } from '../shared/types';
import { createURI, parseURI } from '../shared/utils/URI';
import { CommandID } from '../commands';
import { command$ } from '../observables/command';
import { error$ } from '../observables/error';
export default function (path, selected, copyTo, isRoot, isParent) {
    const { id, path: to } = parseURI(copyTo);
    return [
        ...(isParent ? [] : [
            {
                id: CommandID.Upload,
                label: id == LocalFileSystemID ? 'Copy' : 'Upload',
                click: () => command$.next({ id: CommandID.Upload, uri: createURI(LocalFileSystemID, path) }),
                separator: isRoot
            }
        ]),
        ...((isParent || isRoot) ? [] : [
            {
                id: CommandID.MirrorLocal,
                label: (id == LocalFileSystemID ? 'Copy' : 'Upload') + ' with Relative Path',
                click: () => command$.next({ id: CommandID.MirrorLocal, uri: createURI(LocalFileSystemID, path) }),
                separator: true
            },
        ]),
        ...(isParent ? [] : [
            {
                id: 'new-dir',
                label: 'New Folder...',
                click: () => command$.next({ id: CommandID.NewDir })
            },
            {
                id: 'new-file',
                label: 'New File...',
                click: () => command$.next({ id: CommandID.NewFile }),
                separator: true
            },
        ]),
        {
            id: CommandID.TriggerCopy,
            label: 'Copy',
            click: () => command$.next({ id: CommandID.TriggerCopy })
        },
        {
            id: CommandID.CopyPath,
            label: 'Copy Path',
            click: () => command$.next({ id: CommandID.CopyPath, uri: createURI(LocalFileSystemID, path) })
        },
        ...((isParent || isRoot) ? [] : [
            {
                id: CommandID.CopyRelativePath,
                label: 'Copy Relative Path',
                click: () => command$.next({ id: CommandID.CopyRelativePath, uri: createURI(LocalFileSystemID, path) })
            }
        ]),
        {
            id: CommandID.CopyName,
            label: 'Copy Name',
            click: () => command$.next({ id: CommandID.CopyName, uri: createURI(LocalFileSystemID, path) }),
            separator: true
        },
        {
            id: 'vscode',
            label: "Open in VS Code",
            click: () => window.f5.open(createURI(LocalFileSystemID, path), 'code')
        },
        {
            id: 'open',
            label: 'Show in Finder',
            click: () => { window.f5.open(createURI(LocalFileSystemID, path)); },
            separator: !isParent && !isRoot
        },
        ...((isParent || isRoot) ? [] : [
            {
                id: 'rename',
                label: 'Rename...',
                click: () => command$.next({ id: CommandID.Rename, uri: createURI(LocalFileSystemID, path) })
            },
            {
                id: CommandID.Duplicate,
                label: 'Duplicate',
                click: () => command$.next({ id: CommandID.Duplicate, uri: createURI(LocalFileSystemID, path) })
            },
            {
                id: 'delete',
                label: 'Delete',
                className: 'attention',
                click: () => {
                    error$.next({
                        type: FailureType.ConfirmDeletion,
                        files: ((selected.length && selected.includes(path)) ? selected : [path]).map(path => createURI(LocalFileSystemID, path))
                    });
                }
            }
        ])
    ];
}
